var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"confetti"},[_c('canvas',{ref:"confettiCanvas",staticClass:"confetti__canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }